export const substringInUserTags = (userTags: { username: string }[], s: string) => {
    return userTags.some((tag: { username: string }) => tag.username === s);
};
